export default {
  News(state) {
    return state.news
  },
  PaginationMeta(state) {
    return state.news_info.meta
  },
}
